import qs from 'qs';
import api from '~/utils/api';
import { Company, Group, SelectItem } from '~/types';

export async function getGroups(): Promise<SelectItem[]> {
  const { data } = await api.get<Group[]>('/usuario_logado/filtro/grupo');

  return data.map(it => {
    return {
      value: it.id_grupoeconomico.toString(),
      label: it.nm_grupoeconomico,
    };
  });
}

export async function getHeadOffices(query: any): Promise<SelectItem[]> {
  const { data } = await api.get<Company[]>('/usuario_logado/filtro/matriz', {
    params: {
      ...query,
    },
    paramsSerializer: params => {
      return qs.stringify(params, { arrayFormat: 'repeat' });
    },
  });

  return data.map(it => {
    return {
      value: it.id_empresa.toString(),
      label: `${it.cnpjFormatado} - ${it.nm_razaosocial}`,
    };
  });
}

export async function getBranches(query: any): Promise<SelectItem[]> {
  const { data } = await api.get<Company[]>('/usuario_logado/filtro/filial', {
    params: {
      ...query,
    },
    paramsSerializer: params => {
      return qs.stringify(params, { arrayFormat: 'repeat' });
    },
  });

  return data.map(it => {
    return {
      value: it.id_empresa.toString(),
      label: `${it.cnpjFormatado} - ${it.nm_razaosocial}`,
    };
  });
}
